import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject, Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class UserService {
  public static NODE_API_URL =
    "https://node-backend.chapwood.apps.savantly.cloud/";
  // public static NODE_API_URL = "https://node-backend.chapwood.apps.savantly.cloud/";
  // public static CHAPVEST_PATH = "http://13.57.236.169/resources/";
  public static RESOURCES_PATH = "./assets/resources/";
  public static CHAPTIMIZER_API_URL =
    "https://chapwood-optimizer.chapwood.apps.savantly.cloud/";
  // public static CHAPTIMIZER_API_URL = "http://127.0.0.1:5002/";

  constructor(public http: HttpClient) {}

  isSaving: boolean = false;
  portfolioValue = "";
  public html_body = "";
  enhancerTypes = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
  ];
  enhancers = {
    portfolio_percentage: 20,
    percentage_total: 100,
    ENHANCERS: [
      {
        enhancer_name: "Enhancer 1",
        enhancer_id: 1,
        percentage: 40,
        portfolio_percentage: 8,
      },
      {
        enhancer_name: "Enhancer 2",
        enhancer_id: 2,
        percentage: 30,
        portfolio_percentage: 6,
      },
      {
        enhancer_name: "Enhancer 3",
        enhancer_id: 3,
        percentage: 30,
        portfolio_percentage: 6,
      },
    ],
  };

  current_statistics: any;
  optimized_statistics: any;
  merged_statistics: any;
  allocation_categories: any;
  merged_allocation: any;
  portfolio_percentages = [10, 20, 30, 40, 50, 60, 70, 80, 90];
  is_enhanced = false;
  timer_id: any;

  calculateEnhancerPercentageTotal() {
    for (let i of this.enhancers.ENHANCERS) {
      i.portfolio_percentage =
        this.enhancers.portfolio_percentage * (i.percentage / 100.0);
    }
  }
  public portfolioValueSource = new BehaviorSubject<string>("");
  currentPortfolioValue = this.portfolioValueSource.asObservable();
  public enhancerAllocationSource = new BehaviorSubject<string>("");
  currentEnhancerAllocation = this.enhancerAllocationSource.asObservable();
  public enhancerNumberSource = new BehaviorSubject<string>("");
  currentEnhancerNumber = this.enhancerNumberSource.asObservable();

  public ChaptimizerPercentSource = new BehaviorSubject<string>("");
  ChaptimizerPercent = this.ChaptimizerPercentSource.asObservable();

  public RateOfReturnSource = new BehaviorSubject<string>("");
  Rate_Of_Return = this.RateOfReturnSource.asObservable();

  public StandardDeviationSource = new BehaviorSubject<string>("");
  StandardDeviation = this.StandardDeviationSource.asObservable();

  editPortfolioValue(newPortfolioValue) {
    this.portfolioValueSource.next(newPortfolioValue);
  }
  editEnhancerAllocation(newEnhancerAllocationRate) {
    this.enhancerAllocationSource.next(newEnhancerAllocationRate);
  }
  editEnhancerNumber(newEnhancerNumber) {
    this.enhancerNumberSource.next(newEnhancerNumber);
  }

  editChaptimizerPercent(newChaptimizerPercent) {
    this.ChaptimizerPercentSource.next(newChaptimizerPercent);
  }

  editRateOfReturn(newRateOfReturn) {
    this.RateOfReturnSource.next(newRateOfReturn);
  }

  editStandardDeviation(newStandardDeviation) {
    this.StandardDeviationSource.next(newStandardDeviation);
  }

  /** ============================================ STATISTICS REST API ========================================================= */
  /**
   * Makes a GET request for a specfic statistic
   * @param id The id of the statistic
   */
  getStatistic(id) {
    var url = UserService.NODE_API_URL + "statistics/" + id;
    return this.http.get(url);
  }
  /**
   * Makes a GET request for all statistics
   */
  getStatistics() {
    return this.http.get(UserService.NODE_API_URL + "statistics");
  }
  /**
   * Makes a POST request for a statistic creating a new statistic
   * @param newStatistic The body of the request for a statistic/The new statistic object to be added
   */
  addStatistic(newStatistic) {
    var headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    return this.http.post(
      UserService.NODE_API_URL + "statistics",
      newStatistic,
      { headers: headers },
    );
  }
  /**
   * Makes a DELETE request for a specific statistic
   * @param id The id of the statistic to be deleted
   */
  deleteStatistic(id) {
    return this.http.delete(UserService.NODE_API_URL + "statistics/" + id);
  }
  /** ======================================== ALLOCATIONS REST API ================================================== */
  /**
   * Makes a GET request for a specfic allocation
   * @param id The id of the allocation
   */
  getAllocation(id) {
    var url = UserService.NODE_API_URL + "allocations/" + id;
    return this.http.get(url);
  }
  /**
   * Makes a POST request for an allocation creating a new allocation
   * @param newAllocation  The body of the request for an allocation/The new income expense object to be added
   */
  addAllocation(newAllocation) {
    var headers = new HttpHeaders();
    headers.set("Content-Type", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    // headers.append('Content-Type', 'application/json');
    return this.http.post(
      UserService.NODE_API_URL + "allocations",
      newAllocation,
      { headers: headers },
    );
  }
  /**
   * Makes a PATCH request for an existing allocation
   * @param id The id of the allocation to be edited
   * @param body  The body of the request for an allocation
   */
  editAllocation(id, body) {
    var headers = new HttpHeaders();
    headers.set("Content-Type", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    return this.http.patch(
      UserService.NODE_API_URL + "allocations/" + id,
      body,
    );
  }
  /**
   * Makes a DELETE request for a specific allocation
   * @param id The id of the allocation to be deleted
   */
  deleteAllocation(id) {
    return this.http.delete(UserService.NODE_API_URL + "allocations/" + id);
  }

  /** ======================================== ENHANCED REST API ================================================== */
  /**
   * Makes a GET request for a specfic enhancer
   * @param id The id of the enhancer
   */
  getEnhancer(id) {
    var url = UserService.NODE_API_URL + "enhancers/" + id;
    return this.http.get(url);
  }
  /**
   * Makes a POST request for an enhancer creating a new enhancer
   * @param newEnhancer  The body of the request for an enhancer/The new income expense object to be added
   */
  addEnhancer(newEnhancer) {
    var headers = new HttpHeaders();
    headers.set("Content-Type", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    // headers.append('Content-Type', 'application/json');
    return this.http.post(UserService.NODE_API_URL + "enhancers", newEnhancer, {
      headers: headers,
    });
  }
  /**
   * Makes a PATCH request for an existing enhancer
   * @param id The id of the enhancer to be edited
   * @param body  The body of the request for an enhancer
   */
  editEnhancer(id, body) {
    var headers = new HttpHeaders();
    headers.set("Content-Type", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    return this.http.patch(UserService.NODE_API_URL + "enhancers/" + id, body);
  }
  /**
   * Makes a DELETE request for a specific enhancer
   * @param id The id of the enhancer to be deleted
   */
  deleteEnhancer(id) {
    return this.http.delete(UserService.NODE_API_URL + "enhancers/" + id);
  }

  public getOptimizeURL() {
    return UserService.CHAPTIMIZER_API_URL + "optimizeEnhancer";
  }

  //Makes an POST request to get PDF file
  getPdfFileUrl() {
    return UserService.CHAPTIMIZER_API_URL + "portfolioEnhancerPDF";
  }
  /**
   * Makes a GET request for optimized statistics
   * @param id The uuid for the optimized statistics
   */
  getOptimizeStatsURL(id) {
    return this.http.get(
      UserService.CHAPTIMIZER_API_URL + "chapti_statistics/" + id,
    );
  }

  public getEndpointURL() {
    return UserService.CHAPTIMIZER_API_URL + "optimize";
  }
}
